export const LANG_EN = {
  hello: "Hello",
  sessionInformation: "Session Information",
  remoteSupportPlatform: "Remote Support Platform",
  logIn: "Log in",
  logInWithYourEmailAndPasswordAndYouCanStartTheVideoCallByTypingTheCustomersPhoneNumber: "Log in with your e-mail and password and you can start the video call by typing the customer's phone number.",
  email: "E-mail address",
  password: "Password",
  rememberMe: "Remember me",
  logInUppercase: "LOG IN",
  forgotPassword: "Forgot password?",
  pleaseWaitUppercase: "PLEASE WAIT ...",
  checkYourEmail: "Check your e-mail",
  checkYourPassword: "Check your password",
  loginSuccessfulInitialisingCamera: "Login Successful, initialising Camera!",
  yourDeviceMustHaveAudioAndCameraPermissionsTurnedOn: "Your device must have Audio and Camera permissions turned on. Please check your settings and try again.",
  enterYourEmail: "Enter your e-mail",
  enterYourPassword: "Enter your password",
  date: "Date",
  callId: "Call ID",
  phone: "Phone",
  pin: "Pin",
  areYouSure: "Are you sure?",
  areYouSureYouWantToEndTheCall: "Are you sure you want to end the call?",
  yesDoIt: "YES, DO IT",
  cancel: "Cancel",
  chat: "CHAT",
  typing: "typing...",
  error: "Error",
  pleaseGrantPermissionInSettingsToUseCameraAndMicrophone: "Please grant permission in settings to use camera and microphone",
  ok: "OK",
  pleaseWait: "Please wait",
  informationAndConnectionAreBeingChecked: "Information and connection are being checked",
  pleaseRateOurService: "PLEASE RATE OUR SERVICE",
  yourSessionCallHasBeenFinished: "Your session call has been finished.",
  callFinished: "Call Finished",
  enterYourMessage: "Enter your message",
  rateYourService: "Rate your service",
  heyTechnicianPleaseRateOurService: "Hey Technician, please rate our service.",
  yourFeedbacks: "Your feedbacks",
  enterYourFeedbackHere: "Enter your feedback here",
  submit: "SUBMIT",
  thankYou: "Thank you!",
  thanksForYourTimeForReview: "Thanks for your time for review",
  goToSessionLog: "GO TO SESSION LOG",
  goToDashboard: "GO TO DASHBOARD",
  customerVideoStream: "Customer Video Stream",
  liveSessionVideoCall: "Live Session Video Call",
  flash: "FLASH",
  camera: "CAMERA",
  mic: "MIC",
  mute: "MUTE",
  clearScreen: "CLEAR SCREEN",
  // SHAPES
  "Free Hand": "Free Hand",
  "Free Pencil": "Free Pencil",
  "Circle": "Circle",
  "Move": "Move",
  "Line Up": "Line Up",
  "Rotate Left": "Rotate Left",
  "Rotate Right": "Rotate Right",
  "Color": "Color",
  "Eraser": "Eraser",
  // 
  sessionNotes: "Session Notes",
  save: "Save",
  notes: "Notes",
  enterYourNotesHere: "Enter your notes here",
  addImage: "ADD IMAGE",
  attachedImages: "Attached",
  sessionSummary: "Session Summary",
  completeTheSessionReportBeforeEndingTheCall: "Complete the session report before ending the call",
  isTheIssueSolved: "Is the Issue Solved?",
  sparePart: "Spare Part",
  sessionNotesAndComments: "Session Notes and Comments",
  completeSession: "COMPLETE SESSION",
  endSession: "End Session",
  endAndGoToRating: "END & GO TO RATING",
  endCall: "END CALL",
  privacyPolicyAndTermsOfConditions: "Privacy Policy and Terms of Conditions",
  iApprove: "I approve",
  invalidUrlContactWithYourSupportTeam: "Invalid URL, contact with your support team.",
  welcome: "Welcome",
  joinSupportSession: "Join Support Session",
  yourVideoCallWillBeginShortly: "Your video call will begin shortly.",
  pleaseAcceptTheRelevantLegalNoticeAndStartTheCall: "Please accept the relevant legal notice and start the call.",
  iAgreeToThe: "I agree to the",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  joinVideoCall: "JOIN VIDEO CALL",
  yourSessionIsSecureAndEncrypted: "Your session is secure and encrypted.",
  // Customer Review
  feedback: "Feedback",
  howWasYourSupportSession: "How was your support session?",
  customerExperience: "Customer Experience",
  howWouldYouRateTheQualityOfSupportYouReceived: "How would you rate the quality of support you received?",
  satisfacitionRating: "Satisfacition Rating",
  overallHowSatisfiedAreYouWithTheRemoteSupportSession: "Overall, how satisfied are you with the remote support session?",
  pleaseTakeAMomentToShareYourFeedbackAboutTheRemoteSupportSession: "Please take a moment to share your feedback about the remote support session.",
  // Customer Thanks
  thanksForYourTime: "Thanks for your time!",
  thankYouForWorkingWithUs: "Thank you for working with us.",
  youCanNowCloseYourBrowser: "You can now close your browser.",
  pleaseWaitUntilTheTechnicianEndsTheCall: "Plesae wait for the technician to end the call",
  //
  send: "SEND",
  dashboard: "Dashboard",
  sessionLogs: "Session Logs",
  comingSoon: "Coming Soon",
  forgotPasswordMessage: "Forgot password feature is coming soon.",
  technician: "Technician",
  watchSessionRecording: "Watch Session Recording",
  status: "Status",
  done: "DONE",
  sendToChat: "SEND TO CHAT",
  back: "BACK",
  continueCall: "CONTINUE CALL",
  yourFeedback: "Your Feedback",
  next: "NEXT",
  enterYourFeedbacks: "Enter your feedbacks",
  submitFeedback: "SUBMIT FEEDBACK",
  startVideoRecording: "START VIDEO RECORDİNG",
  stopVideoRecording: "STOP RECORDİNG",
  customerPhoneNumber: "Customer Phone Number:",
  time: "Time",
  duration: "Duration",
  timeLastListed: "Time; Last listed",
  timeFirstListed: "Time; First listed",
  startVideoCall: "START A VIDEO CALL",
  enterTheCustomerPhoneNumber: "Enter the customer's phone number.",
  call: "CALL",
  dateRange: "Date Range",
  state: "State",
  last7Days: "Last 7 Days",
  last30Days: "Last 30 Days",
  last3Months: "Last 3 Months",
  lastYear: "Last Year",
  allTime: "All Time",
  custom: "Custom",
  setDate: "Set Date",
  clear: "Clear",
  result: "Result",
  search: "Search",
  contentIsLoading: "Content is loading",
  iDoNotApprove: "I do not approve",
  youMustApproveTheCallConsentToJoinTheCall: "You must approve the call consent to join the call.",
  doYouWantToEndTheCall: "End the call before leaving the page.",
};